import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

export const Toogle = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

export const ToogleWrapper = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  ${theme.textStyles['text-preset-9']()}
  ${({ disabled }) =>
    disabled &&
    `
    color: ${theme.colors.neutral.text.regular};
  `}
`;

export const ToogleCheckbox = styled.input.attrs(() => ({ type: 'checkbox' }))`
  opacity: ${theme.opacities['opacity-4']};
`;

export const ToogleSwitch = styled.span`
  position: relative;
  display: inline-block;
  min-width: 42px;
  height: 24px;
  margin-left: ${theme.spacing['spacing-2']};
  margin-right: ${theme.spacing['spacing-2']};
  ${({ size }) => getToogleSize(size)};
`;

export const Switch = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: ${theme.borderRadius['border-radius-5']};
  background-color: ${theme.colors.primary.bg.strong};

  &:before {
    position: absolute;
    content: '';
    background-color: ${theme.colors.primary.bg.inverted};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: ${theme.borderRadius['border-radius-5']};
    ${({ size }) => getSpanSize(size)}
  }

  ${ToogleCheckbox}:disabled + & {
    background-color: ${theme.colors.neutral.bg.strong};
  }
  ${ToogleCheckbox}:checked + & {
    background-color: ${theme.colors['secondary-1'].bg.weak};
  }

  ${ToogleCheckbox}:checked:disabled + & {
    background: ${theme.colors.neutral.bg.strong};
  }

  ${ToogleCheckbox}:checked + &:before {
    ${({ size }) => getSpanTransform(size)}
    background-color: ${theme.colors.primary.bg.inverted};
  }

  ${ToogleCheckbox}:disabled + &:before {
    background-color: ${theme.colors.neutral.bg.regular};
  }

  ${ToogleCheckbox}:checked:disabled + &:before {
    background-color: ${theme.colors.neutral.bg.regular};
  }
`;

const getToogleSize = (size) => {
  switch (size) {
    case 'sm':
      return css`
        width: 42px;
        height: 24px;
      `;
    case 'md':
      return css`
        width: 60px;
        height: 34px;
      `;
  }
};

const getSpanSize = (size) => {
  switch (size) {
    case 'sm':
      return css`
        height: 22px;
        width: 22px;
        left: 1px;
        bottom: 1px;
      `;
    case 'md':
      return css`
        height: 26px;
        width: 26px;
        left: ${theme.spacing['spacing-2']};
        bottom: ${theme.spacing['spacing-2']};
      `;
  }
};

const getSpanTransform = (size) => {
  switch (size) {
    case 'sm':
      return css`
        -webkit-transform: translateX(18px);
        -ms-transform: translateX(18px);
        transform: translateX(18px);
      `;
    case 'md':
      return css`
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
      `;
  }
};
